module.exports = __webpack_public_path__ + "01_glasses_brown.454a3703.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer4/01_glasses_brown.png
// module id = TKYW
// module chunks = 0